<template>
  <iframe
    class="field"
    :class="`field-${idMatch}`"
    frameborder="0"
    scrolling="no"
    @load="resize"
  />
</template>

<script>
export default {
  name: 'Scout',
  props: {
    idMatch: {
      required: true,
      type: Number,
    },
    index: {
      required: true,
      type: Number,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initialize();
    });
  },
  updated() {
    this.$nextTick(() => {
      this.initialize();
    });
  },
  computed: {
    url() {
      const { settings } = this.$store.state;
      const { config } = this.$store.state;
      const apiScout = config.API.scout[settings.env];

      return `${apiScout}?mode=tv&source=visualization&server=${settings.env}&lang=${settings.language}&companyUuid=${settings.company.uuid}#${this.idMatch}`;
    },
  },
  methods: {
    initialize() {
      const frame = document.getElementsByClassName(`field-${this.idMatch}`)[0];
      if (frame) frame.src = this.url;
    },
    resize(e) {
      // Resize to correct aspect ratio
      const iframe = e.target || e.path[0];
      const ratio = window.outerWidth / window.outerHeight;
      const parentHeight = iframe.parentElement.clientHeight;

      iframe.style.width = `${ratio * parentHeight}px`;
    },
  },
};
</script>

<style lang="scss" scoped>
.field {
  display: block;
  margin: auto;
  height: 100%;
  width: 100%;
}
</style>
